
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div className="container mx-auto py-8 px-4">
      <Card className="max-w-4xl mx-auto">
        <CardHeader>
          <CardTitle className="text-3xl">Privacy Policy</CardTitle>
          <p className="text-gray-500">Effective Date: March 2, 2025</p>
        </CardHeader>
        <CardContent className="prose max-w-none">
          <p>This Privacy Policy explains how CraveSOS ("we," "our," or "us") collects, uses, and protects your information when you use our mobile application.</p>
          
          <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
          
          <p><strong>1.1 Personal Information</strong></p>
          <ul className="list-disc pl-6 my-2">
            <li>When you sign up, we collect your Google account information via Supabase (name, email address).</li>
            <li>If you contact support, we may collect your email and any details you provide.</li>
          </ul>
          
          <p><strong>1.2 Usage Data</strong></p>
          <ul className="list-disc pl-6 my-2">
            <li>We collect anonymous analytics to improve the App, such as session duration and feature usage.</li>
          </ul>
          
          <p><strong>1.3 Device Data</strong></p>
          <ul className="list-disc pl-6 my-2">
            <li>We may collect device information (e.g., operating system, app version) to diagnose technical issues.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul className="list-disc pl-6 my-2">
            <li>Provide and maintain the App.</li>
            <li>Send you notifications (if enabled).</li>
            <li>Improve our services based on usage trends.</li>
            <li>Comply with legal obligations.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-2">3. Sharing Your Information</h2>
          <p>We do not sell your personal information. We may share data with:</p>
          <ul className="list-disc pl-6 my-2">
            <li>Service providers (e.g., Supabase, Google) for authentication and backend services.</li>
            <li>Legal authorities if required by law.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-2">4. Data Security</h2>
          <p>We take reasonable steps to secure your data, but no method is 100% secure. Use the App at your own risk.</p>

          <h2 className="text-xl font-semibold mt-6 mb-2">5. Your Rights</h2>
          <p>You may request to:</p>
          <ul className="list-disc pl-6 my-2">
            <li>Access the data we store about you.</li>
            <li>Delete your account and associated data.</li>
          </ul>
          <p>For requests, contact us at ryan@maverickinsights.com.</p>

          <h2 className="text-xl font-semibold mt-6 mb-2">6. Third-Party Links</h2>
          <p>The App may contain links to third-party sites (e.g., external resources). We are not responsible for their privacy practices.</p>

          <h2 className="text-xl font-semibold mt-6 mb-2">7. Changes to This Privacy Policy</h2>
          <p>We may update this Privacy Policy. Changes will be reflected in the App.</p>

          <h2 className="text-xl font-semibold mt-6 mb-2">8. Contact Us</h2>
          <p>For privacy-related concerns, contact ryan@maverickinsights.com.</p>
          
          <div className="mt-8 flex justify-center">
            <Link to="/" className="text-blue-600 hover:underline">Back to Home</Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Privacy;
